import styled from "styled-components/macro"

export const Container = styled.div`
  animation: skeleton-loading 1s linear infinite alternate;
  @keyframes skeleton-loading {
    0% {
      background-color: hsl(200, 20%, 60%);
    }
    100% {
      background-color: hsl(200, 20%, 95%);
    }
  }
`

export const Card = styled.div`
  min-width: 160px;
  margin-right: 14px;

  @media (min-width: 768px) {
    min-width: 180px;
  }

  &:nth-child(1) {
    margin-left: 16px;
  }
  @media (min-width: 640px) {
    &:nth-child(1) {
      margin-left: 0;
    }
  }
`

export const Thumbnail = styled.div`
  position: relative;
  width: 160px;
  height: 240px;
  background: #f5f5f5;
  margin-bottom: 6px;
  border-radius: 4px;
  animation: skeleton-loading 1s linear infinite alternate;

  @media (min-width: 768px) {
    width: 180px;
  }
`

export const Rating = styled.div`
  position: absolute;
  width: 46px;
  height: 21px;
  left: 8px;
  bottom: 10px;
  border-radius: 4px;
  background: #e5e5e5;
  z-index: 4;
`

export const Title = styled.div`
  @media (min-width: 640px) {
    width: 110px;
    height: 18.4px;
    background: #e5e5e5;
    margin-bottom: 4px;
    border-radius: 3px;
    animation: skeleton-loading 1s linear infinite alternate;
  }
`

export const Subtitle = styled.div`
  @media (min-width: 640px) {
    width: 60px;
    height: 16.1px;
    margin-bottom: 4px;
    background: #e5e5e5;
    border-radius: 3px;
    animation: skeleton-loading 1s linear infinite alternate;
  }
`
export const lastLine = styled.div`
  width: 90px;
  height: 12px;
  background: #e5e5e5;
`

export const ThreeLine = styled.div`
  width: ${({ w }) => w}%;
  overflow: hidden;
`

export const Text = styled.div`
  width: 100%;
  height: ${({ type }) => (type ? "18.4px" : "16.1px")};
  margin-bottom: 4px;
  background: #e5e5e5;
  border-radius: 3px;
  animation: skeleton-loading 1s linear infinite alternate;
`

export const LastText = styled.div`
  width: 60%;
  height: 16.1px;
  margin-bottom: 4px;
  background: #e5e5e5;
  border-radius: 3px;
  animation: skeleton-loading 1s linear infinite alternate;
`
